// disable auto-story

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import BladeLevel from './blade-level';
import useBladeItemPositioning from './use-blade-item-positioning';

export function BladeLink({ text, href }: NavigationLink) {
  return (
    <li>
      <a className="blade-item" dangerouslySetInnerHTML={{ __html: text }} href={href} />
    </li>
  );
}

interface BladeSubmenuProps extends NavigationSubmenu {
  isOpen?: boolean;
  level?: number;
  onOpen: () => void;
}

export function BladeSubmenu({ items, onOpen, isOpen, level = 0, text }: BladeSubmenuProps) {
  const { top, itemRef } = useBladeItemPositioning();

  const classes = classNames('py-2 text-sm cursor-pointer hover:text-link text-left', {
    'text-link': isOpen,
  });

  return (
    <li>
      <button
        className={twMerge('block w-full right-arrow', classes)}
        dangerouslySetInnerHTML={{ __html: text }}
        onClick={onOpen}
        ref={itemRef}
      />
      <div
        className={twMerge(
          'absolute left-full ml-[2px] transition-all scale-y-100 opacity-100 origin-top',
          !isOpen && 'invisible scale-y-50 opacity-0'
        )}
        style={{ top }}
      >
        <BladeLevel items={items} level={level} />
      </div>
    </li>
  );
}

export function BladeDivider() {
  return <li className="border-t-[1px] my-2" />;
}
